/**
 * Info Box component for banners and alerts - Bitcoin.com React CL Style
 */

import { ReactNode } from 'react'

export interface InfoBoxProps {
  children: ReactNode
  variant?: 'info' | 'success' | 'warning' | 'error'
  title?: string
  icon?: ReactNode
  className?: string
}

export function InfoBox({ children, variant = 'info', title, icon, className }: InfoBoxProps) {
  const variantClasses = {
    info: {
      container: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800',
      icon: 'text-blue-600 dark:text-blue-400',
      title: 'text-blue-900 dark:text-blue-100',
      text: 'text-blue-700 dark:text-blue-300',
    },
    success: {
      container: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800',
      icon: 'text-green-600 dark:text-green-400',
      title: 'text-green-900 dark:text-green-100',
      text: 'text-green-700 dark:text-green-300',
    },
    warning: {
      container: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800',
      icon: 'text-yellow-600 dark:text-yellow-400',
      title: 'text-yellow-900 dark:text-yellow-100',
      text: 'text-yellow-700 dark:text-yellow-300',
    },
    error: {
      container: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800',
      icon: 'text-red-600 dark:text-red-400',
      title: 'text-red-900 dark:text-red-100',
      text: 'text-red-700 dark:text-red-300',
    },
  }

  const classes = variantClasses[variant]

  const defaultIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
      <path d="M12 8V12M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  )

  return (
    <div className={`rounded-xl border p-6 ${classes.container} ${className || ''}`}>
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 ${classes.icon}`}>
          {icon || defaultIcon}
        </div>
        <div className="flex-1">
          {title && (
            <h3 className={`font-bold mb-2 ${classes.title}`}>
              {title}
            </h3>
          )}
          <div className={`text-sm leading-relaxed ${classes.text}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

